import { render, staticRenderFns } from "./BetgameEditName.vue?vue&type=template&id=22269898&scoped=true"
import script from "./BetgameEditName.vue?vue&type=script&lang=js"
export * from "./BetgameEditName.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditName.vue?vue&type=style&index=0&id=22269898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22269898",
  null
  
)

export default component.exports